import { getCaseDataManagerSchema } from 'dashboard/lib/cases/case-data-manager';
import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import {
  CaseTemplate,
  CaseTemplateAttributes,
  CaseTemplateMeta,
} from 'dashboard/models/case-template';
import { setCaseDataManagerSchema, setCaseTemplate } from 'dashboard/redux/actions/case-template';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel, ApiPayload } from 'lib/interfaces/api';
import { DeepPartial } from 'lib/types';

export function loadCaseTemplate(id: string): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const { data, meta } = await SessionClientDashboard.getResource<CaseTemplate, CaseTemplateMeta>(
      ApiEndpoint.CaseTemplate,
      id,
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const caseDataManagerSchema = meta['case-data-manager-schema'];

    dispatch(setCaseTemplate(data));
    dispatch(setCaseDataManagerSchema(getCaseDataManagerSchema(caseDataManagerSchema)));
  };
}

export function updateCaseTemplateV2(
  id: string,
  caseTemplate: CaseTemplate,
  caseActionWorkflowIds?: string[],
  deactivateFieldSchemaKeys?: string[],
): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const { data } = await SessionClientDashboard.updateResource<
      CaseTemplate,
      ApiPayload<
        DeepPartial<CaseTemplateAttributes> & { 'workflow-ids': string[] },
        ApiModel.CaseTemplate
      >
    >(
      {
        type: ApiModel.CaseTemplate,
        id,
        attributes: {
          ...caseTemplate.attributes,
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          'workflow-ids': caseActionWorkflowIds,
        },
      },
      {
        meta: {
          'deactivate-field-schema-keys': deactivateFieldSchemaKeys,
        },
      },
    );

    dispatch(setCaseTemplate(data));
  };
}
